
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Auch wenn es Dutzende von vermeintlichen Mitteln gegen den Kater gibt: Wissenschaftlich erwiesen ist davon nichts, weil die Experimente – falls es überhaupt welche gibt – meist klein und oft fehleranfällig waren. Wenn zum Beispiel nebst dem Alkohol auch fettreiche Speisen verzehrt werden, kann das Resultat anders ausfallen. Am ehesten hilft es, vor der Party genügend Nicht-Alkoholisches zu trinken. Alpha-Linolensäure aus Borretsch nützte in einer Studie. Auch ein Hefe-Vitaminpräparat, Vitamin B6 oder sibirischer Ginseng (Taigawurzel) können eventuell die Katerkopfschmerzen lindern. Vermeiden sollte man Schmerzmittel mit dem Wirkstoff Paracetamol. Er wird von der Leber abgebaut. Dieses Organ ist aber durch den Alkohol sowieso schon gefordert und sollte nicht noch weiter belastet werden. Schmerzmittel wie Ibuprofen oder Acetylsalicylsäure (zum Beispiel in Aspirin) können in Kombination mit dem Alkohol die Magenschleimhaut zusätzlich reizen und das Risiko einer Magenblutung erhöhen. Am sichersten wirkt: Weniger bechern.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;